/* eslint-disable */
import React from "react";
 
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";
 
const Devnagari = (props) => {
 
  return (
      <ReactTransliterate
        value={props.value}
        onChangeText={ props.onChange}
        lang="mr"
        className="form-control mb-0 bg-color ps-2"
        placeholder={props.placeholder}
        onBlur={props.onBlur}
      />
  );
};
 
export default Devnagari;